<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="机构" required prop="institutionCode">
                <el-select v-model="addForm.institutionCode" @change="insChange" placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="选择残疾人" required prop="elderlyCode">
                <el-input v-model="addForm.userName" placeholder="选择残疾人" disabled>
                  <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                  <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="入住套餐" required prop="checkinSetmealCode">
                <el-select v-model="addForm.checkinSetmealCode" placeholder="请选择护理套餐" @change="setmealChange" style="width:100%">
                  <el-option
                      v-for="item in setmealList"
                      :key="item.checkinSetmealCode"
                      :label="item.name"
                      :value="item.checkinSetmealCode">
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.univalence }}(元/月)</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item" >
              <el-form-item label="床号" required prop="berthCode">
                <el-cascader
                    v-model="addForm.berthCode"
                    placeholder="请选择床号"
                    :options="ListBerth" :props="props" style="width:100%"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="月套餐费用">
                <el-input v-model="addForm.feiView" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="月实际费用" required prop="feiTrue">
                <el-input v-model="addForm.feiTrue" placeholder="输入月实际费用"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="预计入住时间">
                <el-date-picker
                    v-model="addForm.beginTimePlan"
                    type="datetime"
                    style="width:100%;"
                    value-format="yyyy-MM-dd hh:mm:ss"
                    placeholder="预计入住时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="预计退住时间">
                <el-date-picker
                    v-model="addForm.endTimePlan"
                    type="datetime"
                    style="width:100%;"
                    value-format="yyyy-MM-dd hh:mm:ss"
                    placeholder="预计退住时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>

    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Elderly from "@/views/Elderly/Comm/ElderlyInsWaitCheckin3";

export default {
  name: 'Add',
  props:['arr_ins'],
  data() {
    return {

      loading: false,

      showModalGetElderly:false,

      typeValue:['正式入住'],

      setmealList:[],
      ListBerth:[],

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        institutionCode:'',
        elderlyCode:'',
        userName:'',

        checkinSetmealCode:'',

        berthCode:'',
        type:0,

        beginTimePlan:'',
        endTimePlan:'',

        feiTrue:0,
        feiView:0,

      },

      props: {
        emitPath:false,
        value: 'value',
        label: 'label',
        children: 'children'
      },

      rules:{

        institutionCode:[
          { required: true, message: '请选择机构', trigger: 'blur' },
        ],
        elderlyCode:[
          { required: true, message: '请选择残疾人', trigger: 'blur' },
        ],
        checkinSetmealCode:[
          { required: true, message: '请选择护理套餐', trigger: 'blur' },
        ],
        berthCode:[
          { required: true, message: '请选择床位', trigger: 'blur' },
        ],
        feiTrue:[
          { required: true, message: '请输入月费用', trigger: 'blur' },
        ],
      },

      type:1,

    }
  },
  components: {
    Elderly
  },
  methods: {
    init(type){
      this.type = type;
      this.$refs.addForm.resetFields();

    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    insChange(val){
      this.addForm.institutionCode = val;

      this.setmealList = [];
      this.listBerth = [];

      this.addForm.checkinSetmealCode = '';
      this.addForm.berthCode = '';

      this.getSetMeal();
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init(this.type,this.addForm.institutionCode);
    },
    setElderly(row){
      this.addForm.elderlyCode = row.elderlyCode;
      this.addForm.userName = row.name;
    },
    clearElderly(){
      this.addForm.elderlyCode = '';
      this.addForm.userName = '';
    },




    getSetMeal:function (){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinSetmeal/InsList",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
          institutionCode:this.addForm.institutionCode,
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.setmealList=response.data.data
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },
    setmealChange(val){

      this.addForm.checkinSetmealCode = val;
      for(let i=0;i<this.setmealList.length;i++){
        if(this.setmealList[i].checkinSetmealCode == val){
          this.addForm.feiView = this.setmealList[i].univalence;
          this.addForm.feiTrue = this.setmealList[i].univalence;
        }
      }


      this.ListBerth = [];
      this.addForm.berthCode = '';
      this.getBerth();

    },


    getBerth:function (){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Berth/InsList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.addForm.institutionCode,
          checkinSetmealCode:this.addForm.checkinSetmealCode,
          berthCode:''
        }
      }).then((response) => {
            //console.log(response);
            if (response.data.error == 0) {

              var datas=response.data.data

              var JSONData=JSON.stringify(datas);
              JSONData=JSONData.replace(/listRoomDTO/g,'children');
              JSONData=JSONData.replace(/listBerth/g,'children');
              JSONData=JSONData.replace(/name/g,'label');
              JSONData=JSONData.replace(/number/g,'label');

              //var list=this.getListBerth(JSON.parse(JSONData),0)
              //JSONData=JSON.stringify(list);

              //JSONData=JSONData.replace(/buildingCode/g,'value');
              //JSONData=JSONData.replace(/roomCode/g,'value');
              JSONData=JSONData.replace(/berthCode/g,'value');

              //console.log(JSONData);
              this.ListBerth=JSON.parse(JSONData);

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },



    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },
    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }
      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Checkin/GovAddIns2",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      })
    },


  }
}


</script>


<style lang="scss" scoped>

</style>
